import { RootState } from "../../../../system/redux/store/community-finder-redux-store";

export const selectCurrentSort = (state: RootState) =>
	state?.results?.currentSort;
